import { createAsyncThunk } from '@reduxjs/toolkit';
import PackageApi from '@infrastructure/packages-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { addSuccessNotification } from '../common/notificationSlice';
import { translate } from '@application/common/helpers/translate';
export const getAllPackagesAsync = createAsyncThunk('packages/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PackageApi.getAllPackages();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFilteredInvoicePackagesAsync = createAsyncThunk('packages/GetFilteredInvoicePackages', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PackageApi.getFilteredInvoicePackages();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignPackageAsync = createAsyncThunk('packages/assign', async (selectedPackage, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await PackageApi.assignPackage(selectedPackage);
        dispatch(addSuccessNotification(translate('account.profileUpdatedSuccessfully')));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
